import { useScrollReveal } from '../hooks/useScrollReveal';
import { Button } from './ui/button';
import { Activity, GraduationCap, Search, Trophy, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconComponents = [Activity, GraduationCap, Search, Trophy];
const pillarIds = ['motion-lab', 'academy', 'scouting', 'goats'];

export const PillarsSection = () => {
  const [ref, isVisible] = useScrollReveal();
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.querySelector(`#${id}`);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="pillars" className="relative py-28 bg-[#0A0A0A]" ref={ref}>
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" />
      <div className="max-w-7xl mx-auto px-6">
        <div className={`mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex items-center gap-3 mb-4"><div className="h-[1px] w-8 bg-[#C9A84C]" /><span className="text-[#C9A84C] text-sm font-medium tracking-[0.2em] uppercase">{t.pillars.tag}</span></div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#F5F0E8] font-heading">{t.pillars.headline}<span className="text-[#C9A84C]">{t.pillars.headlineAccent}</span></h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {t.pillars.cards.map((card, i) => {
            const Icon = iconComponents[i];
            const id = pillarIds[i];
            return (
              <div key={i} className={`group relative p-8 bg-[#111111] border border-[#1F1F1F] rounded-2xl hover:border-[#C9A84C]/30 transition-all duration-500 cursor-pointer ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: `${200 + i * 150}ms` }} onClick={() => id === 'motion-lab' ? window.open('https://gurzimotionlab.com/', '_blank') : scrollTo(id)}>
                <div className="absolute top-0 left-0 w-16 h-[2px] bg-[#C9A84C]/0 group-hover:bg-[#C9A84C]/50 transition-all duration-500 rounded-tl-2xl" />
                <div className="absolute top-0 left-0 w-[2px] h-16 bg-[#C9A84C]/0 group-hover:bg-[#C9A84C]/50 transition-all duration-500 rounded-tl-2xl" />
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 rounded-xl bg-[#C9A84C]/8 border border-[#C9A84C]/15 flex items-center justify-center group-hover:bg-[#C9A84C]/15 group-hover:border-[#C9A84C]/30 transition-all duration-500"><Icon className="text-[#C9A84C]" size={24} /></div>
                  <ArrowRight className="text-[#C9A84C]/0 group-hover:text-[#C9A84C]/60 transition-all duration-500 transform group-hover:translate-x-1" size={20} />
                </div>
                <h3 className={`text-2xl font-bold mb-1 font-heading ${card.title.includes('Gurzí') || card.title.includes('Next Level') ? 'text-[#C9A84C]' : 'text-[#F5F0E8]'}`}>{card.title}</h3>
                {card.subtitle && <p className="text-[#C9A84C] text-sm font-medium mb-4">{card.subtitle}</p>}
                {!card.subtitle && <div className="mb-4" />}
                <p className="text-[#8A8680] text-sm leading-relaxed mb-6">{card.description}</p>
                <Button variant="outline" className="border-[#C9A84C]/20 text-[#C9A84C] hover:bg-[#C9A84C]/10 hover:border-[#C9A84C]/40 text-sm font-medium bg-transparent" onClick={(e) => { e.stopPropagation(); if (id === 'motion-lab') { window.open('https://gurzimotionlab.com/', '_blank'); } else { scrollTo(id); } }}>{card.cta}</Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
